import type { Entity, QueriesObject, QueryResults, System } from '../../odie';

import { BlockComponent } from '../components/BlockComponent';
import { PhaseComponent } from '../components/PhaseComponent';
import { SkullBlockComponent } from '../components/SkullBlockComponent';
import { SkullBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';

/*
    handles skull block specifics
*/
export class SkullBlockSystem implements System {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockSkull';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent, SkullBlockComponent],
    },
    phase: {
      components: [PhaseComponent],
      modified: true,
    },
  };

  // fields
  //-------------------------------------------------------------------------
  // injected
  public scene!: GameScene;
  public queries!: QueryResults;
  private _lastMoveCount?: number;

  // impl
  //-------------------------------------------------------------------------
  public modifiedQuery(
    entity: Entity,
    component: PhaseComponent,
    properties: { phase: string },
  ) {
    // if move input phase step skulls
    if (properties.phase && component.phase === 'input' && component.moved) {
      // Skull (mole) should be restored only if the move count has changed
      // Boosters (hammer, airplane) do not count as moves
      const moveCount = component.moves;
      const moveCountChanged = this._lastMoveCount !== moveCount;
      this._lastMoveCount = moveCount;
      this._stepSkull(moveCountChanged);
    }
  }

  // private: actions
  //-------------------------------------------------------------------------
  private _stepSkull(moveCountChanged: boolean) {
    // restore skulls
    this.queries.block.forEach((entity: SkullBlockEntity) => {
      const skull = entity.c.blockSkull;

      // If skull idle and move count has changed, restore count
      if (skull.idle && moveCountChanged) {
        skull.count = 1;
      }

      // reset idle state
      skull.idle = true;
    });
  }
}
